import React, {Component} from 'react';
import {Form, Input, Modal} from 'antd';

import http from '../../../axios/http';

import messager from '../../ui/messager';

const FormItem = Form.Item;

class UserResetPasswordForm extends Component {

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["username"] = this.props.editData.username;
            http.post({
                url: '/user/resetUserPassword',
                data: values,
                success: (res) => {
                    messager.notify("重置成功！");
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                }
            });
        });
    };

    handleConfirmPassword = (rule, value, callback) => {
        const { getFieldValue } = this.props.form
        if (value && value !== getFieldValue('password')) {
            callback('两次输入不一致！')
        }
        // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
        callback()
    }

    checkPasswordStrong = (rule, value, callback) => {
        const { getFieldValue } = this.props.form
        let idRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@*%])[A-Za-z\d@*&]{10,32}$/;
        let password=getFieldValue('password')
        if (!idRegex.test(password)) {
            callback('密码需为10-32位，包含大小写字母、数字，以及@ * %')
        }
        // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
        callback()
    }

    render() {
        const { visible, onCancel, form } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                visible={visible}
                title="重置用户密码"
                okText="重置"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    <Form.Item label="新密码：" >
                        {getFieldDecorator('password', {
                            rules: [
                                { required: true, message: '请输入新密码!' },
                                { validator: this.checkPasswordStrong}
                            ]
                        })(
                            <Input type="password" />
                        )}
                    </Form.Item>
                    <FormItem label="确认密码：">
                        {getFieldDecorator('confirmPassword', {
                            rules: [
                                { required: true, message: '请输入确认密码!' },
                                {validator: this.handleConfirmPassword}
                            ]
                        })(
                            <Input type="password" />
                        )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
}

const UserResetPassword = Form.create()(UserResetPasswordForm);

export default UserResetPassword;
